import cn from 'clsx'
import { Heading } from '@/components/Text/Heading'
import { Image } from '@/components/image/image'
import { Link } from '@/components/Link/Link'
import { Text } from '@/components/Text/Text'

import css from './FeatureCard.module.css'

export interface FeatureCardProps {
    description?: string
    href: string
    image: {
        src: string
        priority: boolean
        alt?: string
    }
    title: string
    variant?: 'logo' | 'illustrated'
}

function FeatureCard({
    description = '',
    href,
    image: { src, priority, alt = '' },
    title,
    variant = 'logo',
    ...rest
}: FeatureCardProps) {
    return (
        <Link {...rest} className={cn(css.FeatureCard, css[`${variant}`])} href={href}>
            {src && (
                <div className={css.imageWrapper}>
                    <Image src={src} width={48} height={48} priority={priority} alt={alt} />
                </div>
            )}

            <Heading size="major-sm" level="3" title={title}>
                {title}
            </Heading>
            <Text size="body-sm">{description}</Text>
        </Link>
    )
}

export { FeatureCard }
